import { render, staticRenderFns } from "./DataReportOweStatistics.vue?vue&type=template&id=31a6a88b&scoped=true"
import script from "./DataReportOweStatistics.vue?vue&type=script&lang=js"
export * from "./DataReportOweStatistics.vue?vue&type=script&lang=js"
import style0 from "./DataReportOweStatistics.vue?vue&type=style&index=0&id=31a6a88b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_a6c7c6c484daeff6636bea47b922569f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a6a88b",
  null
  
)

export default component.exports